import { put, call, select } from 'redux-saga/effects';
import { Types } from './actions';
import { Types as TypesInformation } from '../getProcedureInformation/actions';
import ProceduresRepository from '../../../repositories/ProceduresRepository';
import ProceduresDataRepository from '../../../../data/repositories/ProceduresDataRepository';
import config from '../../../../core/config/config';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.REGISTER_CHANGE_PHOTO_REQUEST });
    XCheckpointManager.registerStart(
      'Registro / Actualización de fotografía register'
    );
    const proceduresRepository: ProceduresRepository =
      new ProceduresDataRepository();

    let currentPeriod = 'default';

    if (config.DATASOURCE_ENV !== 'MOCK') {
      currentPeriod = yield select((state: any) =>
        String(state.profile?.data?.academic?.period?.id)
      );
    }

    const registerChangePhoto = yield call(
      proceduresRepository.registerChangePhoto,
      action.imgBase64,
      action.fileType,
      currentPeriod
    );

    if (!registerChangePhoto) {
      yield put({
        type: Types.REGISTER_CHANGE_PHOTO_FAILURE,
        error: 'No se pudo registrar'
      });
      return;
    }
    if (registerChangePhoto?.error) {
      // se agrega casusistica asumiendo timout como success
      if (registerChangePhoto.error === 'TIMEOUT') {
        yield put({
          type: 'GET_PROFILE_PHOTO_SUCCESS',
          data: `data:image/jpeg;base64,${action.imgBase64}`
        });
      }
      yield put({
        type: Types.REGISTER_CHANGE_PHOTO_FAILURE,
        requestId: registerChangePhoto?.requestId,
        error:
          registerChangePhoto?.error ||
          'Ocurrió un error al momento de registrar los datos del trámite solicitado.'
      });
      return;
    }

    yield put({
      type: TypesInformation.GET_PROCEDURE_INFORMATION_CLEAR
    });

    yield put({
      type: Types.REGISTER_CHANGE_PHOTO_SUCCESS,
      requestId: registerChangePhoto?.requestId
    });
    XCheckpointManager.registerEnd(
      'Registro / Actualización de fotografía register'
    );
    yield put({
      type: 'GET_PROFILE_PHOTO_SUCCESS',
      data: `data:image/jpeg;base64,${action.imgBase64}`
    });
  } catch (error) {
    yield put({
      type: Types.REGISTER_CHANGE_PHOTO_FAILURE,
      error:
        'Ocurrió un error al momento de registrar los datos del trámite solicitado.'
    });
  }
}
